module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"product-variations":"Product Variations","stock-level":"Stock Level"}}')
  delete Component.options._Ctor
}
